import {styled} from '@mui/material/styles';
import {Box, TextField} from '@mui/material';
// Utility components, shared by different grid-containing pages
export const DataGridFilterField = styled(TextField)(({theme})=>({
    [theme.breakpoints.down('xs')]: {
        width: '100%',
    },
    'margin': '5px 0 0 15px',
    '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(0.5),
    },
    '& .MuiInput-underline:before': {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
}));

export const DataGridContainer = styled(Box)(()=>({
    'flex': 1,
    'flexDirection': 'column',
    'marginTop': '5px',
    'minWidth': '1px !important',
    'maxWidth': 'none !important',
    'width': '100% !important',
    'display': 'flex',
    '&:last-of-type': {
        minWidth: '0 !important',
        flex: 0,
    },
    ['& .rendering-zone']: {
        width: 'initial !important',
        maxWidth: 'initial !important',
    },
}));
